module.exports = __webpack_public_path__ + "img/main.2cb12946.jpeg";